import { render, staticRenderFns } from "./ResultPage.vue?vue&type=template&id=cc201716&scoped=true"
import script from "./ResultPage.vue?vue&type=script&lang=js"
export * from "./ResultPage.vue?vue&type=script&lang=js"
import style0 from "./ResultPage.vue?vue&type=style&index=0&id=cc201716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc201716",
  null
  
)

export default component.exports